<template>
    <div class="p-4 h-full flex flex-col bg-white">
        <p><b>Detalhes da venda</b></p>
        <vs-divider/>
            <div class="bg-white  w-full">
                <slot name="cart-items">
                    <ItemCheckout v-for="(item, index) in itemsCheckout" :key="index" class=" mb-2 " v-show="itemsCheckout.length">
                        <div class="flex flex-row justify-between w-full">
                            <span>{{item.name}}</span>
                            <span>R$ {{formatMoney(item.price)}}</span>
                        </div>
                        <div class="flex flex-col justify-between w-full">
                            <div class="w-full flex flex-row justify-between items-center mt-2">
                                <span>Receber em mãos</span>
                                <vs-checkbox :disabled = "status != 'created' " v-model="item.receivedInHands" color="primary"></vs-checkbox>
                            </div>
                            <div class="w-full flex flex-row justify-between items-center mt-2">
                                <span>Quantidade de parcelas.</span>
                                <number-input class="w-32" :disabled="status != 'created' || item.hasRecurring" :min="1" :max="3" v-model="item.quantity_of_parcels" inline center controls size="small" :inputtable="false"/>
                            </div>
                        </div>
                        <VsDivider />
                    </ItemCheckout>
                    <p class="text-center" v-show="!itemsCheckout.length">O carrinho está vazio</p>
                </slot>
            </div>
        <slot name="cart-total">
            <div>
                <div class="flex justify-between">
                    <span>Subtotal</span>
                    <span>{{formatMoney(total + discounts)}}</span>
                </div>
                <div class="flex justify-between">
                    <span>Descontos</span>
                    <span>{{formatMoney(discounts)}}</span>
                </div>
                <vs-divider/>
                <div class="flex justify-between">
                    <span>Total</span>
                    <span>{{formatMoney(total)}}</span>
                </div>
            </div>
        </slot>
        <div class="h-full w-full">
            <slot name="cart-bottom">
                <vs-button class="h-16 w-full vs-con-loading__container" id="checkout-button" @click="checkout" :disabled="status == 'proccessed'">Efetivar Venda</vs-button>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        Scroll: () => import("vue-perfect-scrollbar"),
        ItemCheckout: () => import("./Components/ItemCheckout")
    },

    props: {
        items: {
            type: Array,
            required: true
        },
        status: {
            required: true,
            type: String,
            validator: (val) => ["created", "proccessed", "proccessing"]
        },
        customer: {
            required: true,
            type: Number
        }
    },
    data(){
        return{
            itemsCheckout : [],
        }

    },
    computed: {
        discounts () {
            return _.sum(this.itemsCheckout.map(item => parseFloat(item.price) - parseFloat(item.priceGiven)));
        },

        total () {
            return _.sum(this.itemsCheckout.map(item => parseFloat(item.priceGiven)));
        }
    },
    methods: {
         formatMoney (valor = 0) {
            valor = parseFloat(valor).toFixed(2).split('.');
            valor[0] = valor[0].split(/(?=(?:...)*$)/).join('.');
            return valor.join(',');
        },

        validateBeforeCheckout() {
            let hasErrors = false;
            const errors = {
                isEmpty: {
                    validate: () => !this.itemsCheckout.length,
                    message: 'O carrinho não pode estar vazio!'
                },
                itemHasErrors: {
                    validate: () => (this.itemsCheckout.filter(item => item.error)).length > 0,
                    message: 'Itens com descontos maiores do que permitidos.'
                },
                noCustomer: {
                    validate: () => !this.customer,
                    message: 'Venda sem cliente não é permitida.'
                },
                ordered: {
                    validate: () => this.status === "proccessed",
                    message: 'Venda já Finalizada'
                }
            }

            const checkErrors = Object.keys(errors).forEach(error => {
                if (errors[error].validate()) {
                    this.$vs.notify({
                        title:'Erro',
                        text:errors[error].message,
                        color:'danger',
                        time: 4000
                    });

                    hasErrors = true;
                }
            });

            return hasErrors;
        },

        checkout () {
            if (this.validateBeforeCheckout()) {
                return false;
            }

            /**Loading */
            this.$vs.loading({
                background: 'primary',
                color: '#fff',
                container: "#checkout-button",
                scale: 0.45
            })

            const items = this.itemsCheckout.map(item =>
                ({
                    itemId: item.systemId,
                    priceGiven: item.priceGiven,
                    packageId: item.packageId,
                    receivedInHands: item.receivedInHands,
                    quantity_of_parcels: item.quantity_of_parcels
                })
            );
            this.$axios.post(`/store`, {customerId: this.customer, items}).then(res => {
            this.$emit('status', 'proccessed');
                this.$vs.loading.close("#checkout-button > .con-vs-loading");
                this.$vs.notify({
                    title:'Venda realizada com Sucesso',
                    text: 'Venda finalizada',
                    color:'success',
                    time: 5000
                });
            }).catch(err => {
                this.$vs.loading.close("#checkout-button > .con-vs-loading");
                this.$vs.notify({
                    title:'Error ao realizar venda',
                    text: `${err.message}. Contate o suporte`,
                    color:'danger',
                    time: 5000
                });
            });
        }

    },
    created(){
        this.itemsCheckout = [...this.items];
    },
    watch: {
        items(items){
            this.itemsCheckout = JSON.parse(JSON.stringify(items));
        }
    },
}
</script>

<style scoped>
    @media only screen and (max-width:600px){

    }
</style>
